.modalTitle {
  display: flex;
  flex-direction: column;
  color: var(--x-color-text-red);
}

.title {
  display: flex;
  justify-content: space-between;
  padding: 15px 0;
  .mobile({
    flex-direction: column;
    align-items: center;
  });
}

.titleControls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.modalPreview {
  :global(.ant-image) img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.downloadBtn {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
